import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GetQueryConfigurationsRequest, GetQueryConfigurationsResponse, QueryConfigurationRequest, QueryConfigurationModel, TestQueryConfigurationRequest, GetTestQueryStoreResultResponse, ExportQueryConfigurationsResponse, ValidateImportQueryConfigurationsCommandResponse } from '../../models/query-configuration.model';
import { ImportRequest } from '../../models/models';

@Injectable({
  providedIn: 'root'
})
export class QueryConfigurationService {
  private api = `${environment.baseV5ApiUri}/QueryConfiguration`;
  constructor(private http: HttpClient) { }

  getAll(request: GetQueryConfigurationsRequest): Observable<GetQueryConfigurationsResponse> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    }

    return this.http.get<GetQueryConfigurationsResponse>(`${this.api}`, { params });
  }

  create(request: QueryConfigurationRequest): Observable<any> {
    return this.http.post(`${this.api}`, request);
  }

  getById(id: string): Observable<QueryConfigurationModel> {
    return this.http.get<QueryConfigurationModel>(`${this.api}/${id}`);
  }

  update(id: string, request: QueryConfigurationRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/${id}`, request);
  }

  delete(id: string)
  {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  testQueryStore(request: TestQueryConfigurationRequest): Observable<GetTestQueryStoreResultResponse> {
    return this.http.post<GetTestQueryStoreResultResponse>(
      `${this.api}/test`,
      request
    );
  }

  export(ids: string[]): Observable<ExportQueryConfigurationsResponse> {
    return this.http.post<ExportQueryConfigurationsResponse>(`${this.api}/export`, ids);
  }

  validateImport(file: File): Observable<ValidateImportQueryConfigurationsCommandResponse> {
    const formData = new FormData();
    formData.append('json', file);

    return this.http.post<ValidateImportQueryConfigurationsCommandResponse>(`${this.api}/validate-import`, formData);
  }

  importEntities(request: ImportRequest): Observable<string[]> {
    return this.http.post<string[]>(`${this.api}/import`, request);
  }

  bulkDelete(ids: string[]): Observable<void> {
    return this.http.delete<void>(`${this.api}/bulk-delete`, { body: ids });
  }
}
